module.exports = __webpack_public_path__ + "static/media/Collei.2c752da0.png";